module.exports = __webpack_public_path__ + "img/appAsset-brand--bsale.eabe9e38.svg";